/**
* Composition for customer logic
*/
export default function () {
  const runtimeConfig = useRuntimeConfig()
  const confGlobal = runtimeConfig.public.confGlobal
  
  const { $member, $i18n: i18n } = useNuxtApp()
  const { requestHeaders } = useApi()
  const { useCustomCookie, trackEventQueue } = useCustomTools()
  const toast = useToast()
  const { hasFaq } = useFaq()

  /**
  * If client already Registered
  */
  const alreadyRegistered = useState('customer_alreadyRegistered', () => false)

  /**
  * SalesRep info
  */
  const salesRep = useCustomCookie('salesRep')

  /**
  * SalesRep info
  */
  const expiredModal = () => {
    console.log('expired')

    setTimeout(() => {
      toast.add({ severity: 'secondary', title: i18n?.t('sessionExpiredTitle'), summary: i18n?.t('sessionExpiredDescr'), group: 'sessionExpired'  })
    }, 1500)

    salesRep.value = false
    hasFaq.value = false
  }

  /**
  * Set Referral
  */
  const setReferral = () => {
    try {
      return $fetch(confGlobal.apiUrl + '/referrals', {
        method: 'POST',
        body: {
          referral: $member.referralToken.value
        },
        headers: requestHeaders()
      }).then(() => {
        $member.referralToken.value = false
      }).catch(() => {
        $member.referralToken.value = false
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Get Sales Rep
  */
  const getSalesRep = () => {
    try {
      return $fetch(confGlobal.apiUrl + '/customers/sales-rep', {
        method: 'GET',
        headers: requestHeaders()
      }).then(async (res) => {
        const salesRepData = await res
        salesRep.value = salesRepData.data

        return true
      }).catch(async (err) => {
        console.log(await err)

        return true
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Clear Customed Data in State and Storage
  */
  const clearCustomerData = () => {
    if (typeof window !== 'undefined') {
      const statePayloadKeys = Object.keys(useNuxtApp().payload.state)
      statePayloadKeys.forEach(key => {
        if (key.startsWith('customer_') || key.startsWith('$scustomer_') || key.startsWith('member') || key.startsWith('$smember')) {
          clearNuxtState(key?.replace('$s', ''))
        }
      })

      const dataPayloadKeys = Object.keys(useNuxtApp().payload.data)
      dataPayloadKeys.forEach(key => {
        if (key.startsWith('customer_') || key.startsWith('$scustomer_') || key.startsWith('member') || key.startsWith('$smember')) {
          clearNuxtData(key)
        }
      })
    }
  }

  /**
  * Register Endpoint
  */
  const register = async (data) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/auth/register', {
        method: 'POST',
        headers: requestHeaders(),
        body: JSON.stringify(data)
      }).then(async (res) => {
        /**
        * GTM
        * login
        */
        trackEventQueue.value.push({
          event: 'register',
          user_id: data.email
        })

        return { status: 'success', data: await res }
      }).catch((err) => {
        if (err.data && err?.data?.error && err?.data?.error?.description) {
          const errors = []

          if (typeof err?.data?.error?.description === 'object') {
            for (const i in err?.data?.error?.description) {
              if (typeof err?.data?.error?.description[i] === 'object') {
                for (const m in err?.data?.error?.description[i]) {
                  errors.push(err?.data?.error?.description[i][m])
                }
              } else {
                errors.push(err?.data?.error?.description[i])
              }
            }
          } else {
            errors.push(err?.data?.error?.description)
          }

          return { status: 'error', description: errors }
        }
      })
    } catch (err) {
      console.log(err)
      toast.add({
        severity: 'error',
        detail: i18n?.t('serverError'),
        life: 5000
      })
    }
  }

  /**
  * Login Endpoint
  */
  const login = async (data) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/auth/login', {
        method: 'POST',
        headers: requestHeaders(),
        body: JSON.stringify(data)
      }).then(async (res) => {
        /**
        * Delete the previous user's data
        */
        clearCustomerData()

        /**
        * Customer Data
        */
        const currentMemberToken = await res.data
        if (currentMemberToken) {
          useCustomCookie('subscribeModalNotAllow').value = true

          $member.memberToken.value = currentMemberToken

          $member.getMember()
        }

        /**
        * GTM
        * login
        */
        trackEventQueue.value.push({
          event: 'login',
          user_id: data.username
        })

        return { status: 'success', data: currentMemberToken }
      }).catch((err) => {
        console.log(err)
        if (err.data && err?.data?.error && err?.data?.error?.description) {
          const errors = []

          if (typeof err?.data?.error?.description === 'object') {
            for (const i in err?.data?.error?.description) {
              if (typeof err?.data?.error?.description[i] === 'object') {
                for (const m in err?.data?.error?.description[i]) {
                  errors.push(err?.data?.error?.description[i][m])
                }
              } else {
                errors.push(err?.data?.error?.description[i])
              }
            }
          } else {
            errors.push(err?.data?.error?.description)
          }

          console.log(err)

          return { status: 'error', description: errors }
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  const setAuthToken = (currentMemberToken) => {
    return new Promise((resolve, reject) => {
      if (currentMemberToken) {
        useCustomCookie('subscribeModalNotAllow').value = true
        $member.memberToken.value = currentMemberToken
        
        /**
        * GTM
        * login
        */
        trackEventQueue.value.push({
          event: 'login'
        })
        resolve()
      } else {
        reject()
      }
    })
  }

  /**
  * Forgot Password Endpoint
  */
  const forgot = async (data) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/password/forgot', {
        method: 'POST',
        headers: requestHeaders(),
        body: JSON.stringify(data)
      }).then(async (res) => {
        if (res.success) {
          return await res
        } else {
          toast.add({
            severity: 'error',
            detail: i18n?.t('forgotSendedError'),
            life: 5000
          })
          return { status: 'error' }
        }
      }).catch((err) => {
        if (err.data && err?.data?.error && err?.data?.error?.description) {
          const errors = []

          if (typeof err?.data?.error?.description === 'object') {
            for (const i in err?.data?.error?.description) {
              if (typeof err?.data?.error?.description[i] === 'object') {
                for (const m in err?.data?.error?.description[i]) {
                  errors.push(err?.data?.error?.description[i][m])
                }
              } else {
                errors.push(err?.data?.error?.description[i])
              }
            }
          } else {
            errors.push(err?.data?.error?.description)
          }

          return { status: 'error', description: errors }
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Reset Password Endpoint
  */
  const resetPassword = async (data) => {
    try {
      return await $fetch(confGlobal.apiUrl + '/password/reset', {
        method: 'POST',
        headers: requestHeaders(),
        body: JSON.stringify(data)
      }).then(async (res) => {
        if (res.success) {
          return await res
        } else {
          toast.add({
            severity: 'error',
            detail: i18n?.t('resetSendedError'),
            life: 5000
          })
          return { status: 'error' }
        }
      }).catch((err) => {
        if (err.data && err?.data?.error && err?.data?.error?.description) {
          const errors = []

          if (typeof err?.data?.error?.description === 'object') {
            for (const i in err?.data?.error?.description) {
              if (typeof err?.data?.error?.description[i] === 'object') {
                for (const m in err?.data?.error?.description[i]) {
                  errors.push(err?.data?.error?.description[i][m])
                }
              } else {
                errors.push(err?.data?.error?.description[i])
              }
            }
          } else {
            errors.push(err?.data?.error?.description)
          }

          console.log(err)

          return { status: 'error', description: errors }
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  /**
  * Handle resend verification email using register function
  */
  const handleResendVerification = async () => {
    if (!$member.user.value.email) return

    // Create form data object with user's existing information
    const formData = {
      email: $member.user.value.email,
      // Add any other required fields your PHP backend expects
      resend_verification: true // Flag to indicate this is a resend request
    }

    try {
      const data = await register(formData)
      
      if (data?.status === 'error') {
        // Handle errors - show error toast with specific message
        const errorMessage = Array.isArray(data.description) ? data.description[0] : data.description
        toast.add({
          severity: 'error',
          detail: errorMessage || i18n?.t('verificationEmailError'),
          life: 5000
        })
        console.error('Resend verification error:', data.description)
        return { status: 'error', message: errorMessage }
      } else if (data?.status === 'registered') {
        // User already registered, verification email sent
        console.log('Verification email resent successfully')
        return { status: 'success' }
      } else if (data?.data?.token) {
        // Handle token response if needed
        const token = data.data.token
        await setAuthToken(token)
        return { status: 'success' }
      } else {
        // Default success case
        return { status: 'success' }
      }
    } catch (error) {
      console.error('Resend verification error:', error)
      toast.add({
        severity: 'error',
        detail: i18n?.t('verificationEmailError'),
        life: 5000
      })
      return { status: 'error', message: 'Failed to send verification email' }
    }
  }

  /**
  * Return Object
  */
  return {
    alreadyRegistered,
    expiredModal,

    salesRep,
    getSalesRep,

    setReferral,

    clearCustomerData,
    setAuthToken,

    register,
    login,
    forgot,
    resetPassword,
    handleResendVerification
  }
}
